import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, MoreVertical } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '../../components/ui/DropdownMenu';
import { riveFiles } from '../../src/seed';
export function RiveLibrary() {
  const navigate = useNavigate();
  return <div className="space-y-6" data-id="element-724">
      <div data-id="element-725">
        <h1 className="text-3xl font-bold tracking-tight" data-id="element-726">Library</h1>
        <p className="text-muted-foreground" data-id="element-727">
          All Rive animations across all collections
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-728">
        {riveFiles.map(file => <Card key={file.id} className="cursor-pointer hover:shadow-md transition-shadow group" onClick={() => navigate(`/rive/library/${file.id}`)} data-id="element-729">
            <CardContent className="p-4 flex items-center gap-4" data-id="element-730">
              <div className="size-16 aspect-square bg-muted rounded-lg flex items-center justify-center shrink-0" data-id="element-731">
                <Play className="h-6 w-6 text-muted-foreground/40" data-id="element-732" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-733">
                <div className="flex items-start justify-between" data-id="element-734">
                  <h3 className="font-semibold text-base truncate mb-1" data-id="element-735">
                    {file.name}
                  </h3>
                  <DropdownMenu data-id="element-736">
                    <DropdownMenuTrigger asChild onClick={e => e.stopPropagation()} data-id="element-737">
                      <Button variant="ghost" size="icon" className="h-8 w-8 -mr-2 -mt-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-738">
                        <MoreVertical className="h-4 w-4" data-id="element-739" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" data-id="element-740">
                      <DropdownMenuItem onClick={e => e.stopPropagation()} data-id="element-741">
                        Edit
                      </DropdownMenuItem>
                      <DropdownMenuItem onClick={e => e.stopPropagation()} className="text-destructive" data-id="element-742">
                        Delete
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>
                <p className="text-xs text-muted-foreground mb-2" data-id="element-743">
                  {file.sizeKb} KB · {file.eventCount} events · {file.useCase}
                </p>
                <div className="flex gap-2" data-id="element-744">
                  <Badge variant={file.hasTimeline ? 'default' : 'secondary'} className={`text-[10px] px-1.5 py-0 ${file.hasTimeline ? 'bg-green-600 hover:bg-green-700' : ''}`} data-id="element-745">
                    Timeline
                  </Badge>
                  <Badge variant={file.isPublished ? 'default' : 'secondary'} className={`text-[10px] px-1.5 py-0 ${file.isPublished ? 'bg-green-600 hover:bg-green-700' : ''}`} data-id="element-746">
                    Published
                  </Badge>
                </div>
              </div>
            </CardContent>
          </Card>)}
      </div>
    </div>;
}